import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import EmailIcon from "@material-ui/icons/Email";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  card: {
    marginBottom: 16,
    position: "relative",
  },
  checkboxContainer: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
  },
  cardActions: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: "8px 16px",
  },
  groupInfo: {
    marginBottom: 12,
  },
});

export default function GroupCard({
  group,
  index,
  onToggle,
  onEdit,
  onMembers,
  onEmail,
  isChecked,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onToggle(group.name);
  };

  return (
    <Card className={classes.card} variant="outlined">
      <div className={`tour-group-select-${index} ${classes.checkboxContainer}`}>
        <Checkbox
          checked={isChecked}
          onChange={handleCheckboxClick}
          color="primary"
        />
      </div>

      <CardContent>
        <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 8, paddingRight: 40 }}>
          {group.name}
        </Typography>

        <div className={classes.groupInfo}>
          <Typography variant="caption" style={{ color: "#666" }}>
            Description
          </Typography>
          <Typography variant="body2" style={{ marginTop: 4 }}>
            {group.description && group.description !== "-" ? group.description : "No description"}
          </Typography>
        </div>

        <div className={classes.groupInfo}>
          <Typography variant="caption" style={{ color: "#666" }}>
            Members
          </Typography>
          <div style={{ marginTop: 4 }}>
            <Chip
              label={group.number}
              size="small"
              color="primary"
              style={{ fontWeight: 500 }}
            />
          </div>
        </div>
      </CardContent>

      <CardActions className={classes.cardActions}>
        <Button
          color="info"
          size="sm"
          fullWidth
          onClick={() => onEdit(group)}
        >
          <EditIcon style={{ marginRight: 4 }} />
          {t("dashboard:editGroupDetails")}
        </Button>

        <Button
          color="warning"
          size="sm"
          fullWidth
          onClick={() => onMembers(group)}
        >
          <GroupAddIcon style={{ marginRight: 4 }} />
          {t("dashboard:viewAddMembers")}
        </Button>

        <Button
          color="darkBlue"
          size="sm"
          fullWidth
          onClick={() => onEmail(group)}
        >
          <EmailIcon style={{ marginRight: 4 }} />
          {t("dashboard:sendEmail")}
        </Button>
      </CardActions>
    </Card>
  );
}
